import React from "react";
import "../styles/global.css";
import { useNavigate } from "react-router-dom";
function About() {
  const navigate = useNavigate();
  return (
    <div style={styles.container}>
      {/* Intro */}
      <section style={styles.section}>
        <h1 style={styles.heading}>Welcome to The Tasty Dine 🍴</h1>
        <p style={styles.subheading}>
          A perfect blend of taste, tradition & innovation since 2010
        </p>
      </section>

      {/* Our Story */}
      <section style={styles.section}>
        <h2 style={styles.title}>🥘 Our Story</h2>
        <p style={styles.text}>
          "The Tasty Dine" began as a small family-run restaurant in the heart of
          the city. What started with a handful of recipes passed down through
          generations is now one of the most loved food destinations for people
          seeking both comfort and class on a plate.
        </p>
        <p style={styles.text}>
          Over the years, our passion for food and customer satisfaction turned
          us into a name synonymous with quality, authenticity, and innovation in
          cuisine. Every dish we serve has a story, a tradition, and a soul.
        </p>
      </section>

      {/* Philosophy */}
      <section style={styles.section}>
        <h2 style={styles.title}>💡 Our Philosophy</h2>
        <p style={styles.text}>
          We believe that food isn't just about taste—it's about experience. At
          The Tasty Dine, we aim to deliver joy through thoughtfully prepared
          meals, warm hospitality, and a welcoming ambiance. Sustainability and
          locally sourced ingredients form the heart of our kitchen practices.
        </p>
      </section>

      {/* Chef Section */}
      <section style={styles.section}>
        <h2 style={styles.title}>👨‍🍳 Meet Our Master Chef</h2>
        <div style={styles.chefContainer}>
          <img
            src="/images/chef burak.jpeg"
            alt="Chef"
            style={{ ...styles.chefImage, marginLeft: "28rem" }}
          />
          <div>
            <p style={styles.text}>
              Chef Burak Özdemir, globally known for his charisma and creativity in the kitchen,
              brings a vibrant energy to The Tasty Dine. Famous for his dramatic cooking style and
              innovative dishes, Chef Burak fuses traditional Turkish flavors with modern presentation.
            </p>
            <p style={styles.text}>
              His unique culinary vision has elevated our restaurant to an international level,
              attracting food lovers from all around the world. With Chef Burak at the helm,
              every plate is a spectacle — both in flavor and flair.
            </p>

          </div>
        </div>
      </section>

      {/* Restaurant Highlights */}
      <section style={styles.section}>
        <h2 style={styles.title}>🌟 What Makes Us Special</h2>
        <div style={styles.imageGrid}>
          <img
            src="/images/interior.jpg"
            alt="Cozy Interiors"
            style={styles.gridImage}
          />
          <img
            src="/images/enjoy.jpg"
            alt="Family Enjoying Meal"
            style={styles.gridImage}
          />
          <img
            src="/images/waiter2.jpeg"
            alt="Waiter Serving"
            style={styles.gridImage}
          />
        </div>
      </section>

      {/* Testimonials */}
      <section style={styles.section}>
        <h2 style={styles.title}>❤️ Why People Love Us</h2>
        <ul style={styles.bulletPoints}>
          <li>✔️ Fresh and locally sourced ingredients</li>
          <li>✔️ Unique fusion of Indian & international cuisine</li>
          <li>✔️ Cozy ambiance for all occasions</li>
          <li>✔️ Friendly and professional staff</li>
          <li>✔️ Quick service and easy online ordering</li>
        </ul>
      </section>

      {/* CTA */}
      <section style={{ ...styles.section, textAlign: "center" }}>
        <p style={{ fontSize: "1.2rem" }}>
          ✨ Whether you're dining in or ordering online, The Tasty Dine promises
          a flavorful journey every single time.
        </p>
        <button onClick={()=>navigate("/booking")} style={styles.ctaButton}>🍽️ Book a Party Hall</button>
        <p style={{ marginTop: "1rem", fontStyle: "italic", color: "#999" }}>
          Or <a href="/menu">explore our full menu →</a>
        </p>
      </section>
    </div>
  );
}

const styles = {
  container: {
    padding: "2rem",
    fontFamily: "Poppins, sans-serif",
    backgroundColor: "white",
  },
  section: {
    marginBottom: "3rem",
    backgroundColor: "#fff8f0",
    padding: "2rem",
    borderRadius: "10px",
    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
  },

  heading: {
    fontSize: "2.8rem",
    color: "#d9534f",
    textAlign: "center",
    marginBottom: "0.5rem",
  },
  subheading: {
    fontSize: "1.2rem",
    color: "#555",
    textAlign: "center",
    marginBottom: "2rem",
  },
  title: {
    fontSize: "1.8rem",
    color: "#d9534f",
    marginBottom: "1rem",
  },
  text: {
    fontSize: "1rem",
    lineHeight: "1.8",
    color: "#333",
    marginBottom: "1rem",
    textAlign: "justify",
  },
  chefContainer: {
    display: "flex",
    gap: "1.5rem",
    flexWrap: "wrap",
    alignItems: "center",
  },
  chefImage: {
    width: "300px",
    borderRadius: "10px",
    objectFit: "cover",
    boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
  },
  imageGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
    gap: "1.5rem",
  },
  gridImage: {
    width: "100%",
    borderRadius: "12px",
    objectFit: "cover",
    height: "200px",
    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
  },
  bulletPoints: {
    listStyle: "none",
    paddingLeft: 0,
    fontSize: "1rem",
    lineHeight: "2",
    color: "#444",
  },
  ctaButton: {
    marginTop: "1rem",
    backgroundColor: "#d9534f",
    color: "#fff",
    padding: "0.75rem 1.5rem",
    border: "none",
    fontSize: "1rem",
    borderRadius: "8px",
    cursor: "pointer",
  },
};

export default About;
